<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('cost')"
          :directory="[$t('costs'), $t('cost')]"
          :icon="'users'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="text-sm-right mb-primary mb-sm-0 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openModal()"
          >
            {{ $t("add_cost") }}
          </button>
        </div>
      </div>
    </div>
    <app-table :id="tableId" :options="options" @action="getAction" />

    <app-cost-modal
      v-if="isCostModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeModal"
    />
    <app-confirmation-modal
      v-if="confirmationModalActive"
      modal-id="cost-delete-modal"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />

    
  </div>
</template>
<script>
import CoreLibrary from "@core/helpers/CoreLibrary.js";
import { formatDateToLocal, collection, urlGenerator, numberWithCurrencyMuseum } from "@app/Helpers/helpers";
import { mapGetters } from "vuex";
import { owner, costType, organization, tag } from "@app/Mixins/Global/FilterMixins";
import { DeleteMixin } from "@app/Mixins/Global/DeleteMixin";
export default {
  name: "Cost",
  extends: CoreLibrary,
  mixins: [owner, costType, DeleteMixin],
  data() {
    return {
	  formatDateToLocal,
    numberWithCurrencyMuseum,
      urlGenerator,
      isCostModalActive: false,
      tableId: "cost-modal",
      confirmationModalActive: false,
    
      editedUrl: "",

      noteRowData: null,
      costId: null,
      selectedUrl: "",
      activityData: {},
      followerUrl: "",
      options: {
        name: this.$t("cost_table"),
        url: "crm/costs",
        showHeader: true,
        countView: true,
        columns: [
        {
          title: this.$t("cost_groups"),
          type: "custom-html",
          key: "cost_type",
          modifier: (value, row) => {
            return value
              ? `<span class="badge badge-pill badge-${value.class ?? "secondary"}">${
                  value.name
                }</span>`
              : "-";
          },
        },
        {
          title: this.$t("cost_price"),
          type: "custom-html",
          key: "price",
          modifier: (value, row) => {
            return value
              ? `<span class="text-nowrap">${numberWithCurrencyMuseum(row.price)}</span>`
              : "-";
          },
        },

        {
          title: this.$t("cost_person_or_owner"),
          type: "custom-html",
          key: "person",
          modifier: (value, row) => {
   
            if(row.person || row.user){
              if(row.status_id == 1){

                let url = '/crm/persons/' + value.id + '/edit';
                return '<a href="' + url + '" class="text-nowrap">' + value.name + '</a><small> ('+ this.$t('cost_person') +')</small>';
              }else if(row.status_id == 2){
                return '<span class="text-nowrap">' + row.user.full_name + '</span><small> ('+ this.$t('cost_person_owner') +')</small>';
              }else{
                return '-';
              }
            }else{
              return '-';
            }
            
            
            
          },
        },
		
        
        
        
       
       
        
      

		{
          title: this.$t("due_date"),
          type: "custom-html",
          key: "due_date",
          modifier: (value, row) => {
            return value
              ? `<span class="text-nowrap">${formatDateToLocal(row.due_date)}</span>`
              : "-";
          },
        },
        {
          title: this.$t("owner"),
          type: "object",
          key: "owner",
          modifier: (value, row) => {
            return value ? value.full_name : "";
          },
        },
		
        {
          title: this.$t("action"),
          type: "action",
          key: "invoice",
          isVisible: true,
        },
      ],
        filters: [
          {
            title: this.$t("created_date"),
            type: "range-picker",
            key: "dateDue",
            option: ["today", "thisMonth", "last7Days", "thisYear"],
          },
          {
            title: this.$t("owner"),
            type: "checkbox",
            key: "owner_is",
            option: [],
          },
          {
            title: this.$t("cost_group"),
            type: "checkbox",
            key: "cost_type",
            option: [],
          },
  
        ],
        showSearch: true,
        showFilter: true,
        paginationType: "pagination",
        responsive: false,
        rowLimit: 20,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "modal",
            component: "app-cost-modal",
            modalId: "cost-modal",
            url: "",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "modal",
            component: "app-confirmation-modal",
            modalId: "cost-delete-modal",
            url: "",
          },
        ],
      },
    };
  },
  methods: {
    getAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `crm/costs/${rowData.id}`;
        this.isCostModalActive = true;
      } else if (actionObj.title == this.$t("delete")) {
        this.deleteUrl = `crm/costs/${rowData.id}`;
        this.confirmationModalActive = true;
      }
    },
    openModal() {
      this.isCostModalActive = true;
    },
   
    closeModal() {
      this.isCostModalActive = false;
      this.selectedUrl = "";
      $("#cost-modal").modal("hide");
    },
   
   
   
   
  },
  computed: {
    ...mapGetters({
      //organizationList: "getOrganization",
    }),
  },
  mounted() {
  },
};
</script>
<style>
.link-list {
  white-space: nowrap !important;
  max-width: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
